var map = {
	"./account-statement.svg": "./src/components/nav-bars-shared/nav-bar/icons/account-statement.svg",
	"./audits.svg": "./src/components/nav-bars-shared/nav-bar/icons/audits.svg",
	"./bag-icon.svg": "./src/components/nav-bars-shared/nav-bar/icons/bag-icon.svg",
	"./bar-report.svg": "./src/components/nav-bars-shared/nav-bar/icons/bar-report.svg",
	"./bars.svg": "./src/components/nav-bars-shared/nav-bar/icons/bars.svg",
	"./bookings.svg": "./src/components/nav-bars-shared/nav-bar/icons/bookings.svg",
	"./business-inteligence.svg": "./src/components/nav-bars-shared/nav-bar/icons/business-inteligence.svg",
	"./business-intelligence-v2.svg": "./src/components/nav-bars-shared/nav-bar/icons/business-intelligence-v2.svg",
	"./cargo-cart.svg": "./src/components/nav-bars-shared/nav-bar/icons/cargo-cart.svg",
	"./cash-flow.svg": "./src/components/nav-bars-shared/nav-bar/icons/cash-flow.svg",
	"./change-language.svg": "./src/components/nav-bars-shared/nav-bar/icons/change-language.svg",
	"./chart-of-accounts-v2.svg": "./src/components/nav-bars-shared/nav-bar/icons/chart-of-accounts-v2.svg",
	"./chart-of-accounts.svg": "./src/components/nav-bars-shared/nav-bar/icons/chart-of-accounts.svg",
	"./clients.svg": "./src/components/nav-bars-shared/nav-bar/icons/clients.svg",
	"./communication.svg": "./src/components/nav-bars-shared/nav-bar/icons/communication.svg",
	"./config-adm.svg": "./src/components/nav-bars-shared/nav-bar/icons/config-adm.svg",
	"./contract.svg": "./src/components/nav-bars-shared/nav-bar/icons/contract.svg",
	"./crm.svg": "./src/components/nav-bars-shared/nav-bar/icons/crm.svg",
	"./customers.svg": "./src/components/nav-bars-shared/nav-bar/icons/customers.svg",
	"./delivery-person-white.svg": "./src/components/nav-bars-shared/nav-bar/icons/delivery-person-white.svg",
	"./delivery.svg": "./src/components/nav-bars-shared/nav-bar/icons/delivery.svg",
	"./devices.svg": "./src/components/nav-bars-shared/nav-bar/icons/devices.svg",
	"./employee.svg": "./src/components/nav-bars-shared/nav-bar/icons/employee.svg",
	"./event-operation.svg": "./src/components/nav-bars-shared/nav-bar/icons/event-operation.svg",
	"./events.svg": "./src/components/nav-bars-shared/nav-bar/icons/events.svg",
	"./file-check.svg": "./src/components/nav-bars-shared/nav-bar/icons/file-check.svg",
	"./financial-report.svg": "./src/components/nav-bars-shared/nav-bar/icons/financial-report.svg",
	"./financial.svg": "./src/components/nav-bars-shared/nav-bar/icons/financial.svg",
	"./fiscal.svg": "./src/components/nav-bars-shared/nav-bar/icons/fiscal.svg",
	"./giftback.svg": "./src/components/nav-bars-shared/nav-bar/icons/giftback.svg",
	"./list-multiple.svg": "./src/components/nav-bars-shared/nav-bar/icons/list-multiple.svg",
	"./logout.svg": "./src/components/nav-bars-shared/nav-bar/icons/logout.svg",
	"./loyalty.svg": "./src/components/nav-bars-shared/nav-bar/icons/loyalty.svg",
	"./multivendor-v2.svg": "./src/components/nav-bars-shared/nav-bar/icons/multivendor-v2.svg",
	"./multivendor.svg": "./src/components/nav-bars-shared/nav-bar/icons/multivendor.svg",
	"./new-storage.svg": "./src/components/nav-bars-shared/nav-bar/icons/new-storage.svg",
	"./operation.svg": "./src/components/nav-bars-shared/nav-bar/icons/operation.svg",
	"./packages.svg": "./src/components/nav-bars-shared/nav-bar/icons/packages.svg",
	"./panel.svg": "./src/components/nav-bars-shared/nav-bar/icons/panel.svg",
	"./password-card.svg": "./src/components/nav-bars-shared/nav-bar/icons/password-card.svg",
	"./pdv-status.svg": "./src/components/nav-bars-shared/nav-bar/icons/pdv-status.svg",
	"./place.svg": "./src/components/nav-bars-shared/nav-bar/icons/place.svg",
	"./pos-machine.svg": "./src/components/nav-bars-shared/nav-bar/icons/pos-machine.svg",
	"./pre-charge.svg": "./src/components/nav-bars-shared/nav-bar/icons/pre-charge.svg",
	"./precharge.svg": "./src/components/nav-bars-shared/nav-bar/icons/precharge.svg",
	"./products.svg": "./src/components/nav-bars-shared/nav-bar/icons/products.svg",
	"./promotions.svg": "./src/components/nav-bars-shared/nav-bar/icons/promotions.svg",
	"./receptive.svg": "./src/components/nav-bars-shared/nav-bar/icons/receptive.svg",
	"./recharge-management.svg": "./src/components/nav-bars-shared/nav-bar/icons/recharge-management.svg",
	"./report.svg": "./src/components/nav-bars-shared/nav-bar/icons/report.svg",
	"./reports.svg": "./src/components/nav-bars-shared/nav-bar/icons/reports.svg",
	"./request-devices.svg": "./src/components/nav-bars-shared/nav-bar/icons/request-devices.svg",
	"./reserve.svg": "./src/components/nav-bars-shared/nav-bar/icons/reserve.svg",
	"./roi.svg": "./src/components/nav-bars-shared/nav-bar/icons/roi.svg",
	"./satisfaction-survey.svg": "./src/components/nav-bars-shared/nav-bar/icons/satisfaction-survey.svg",
	"./sell-with-no-card.svg": "./src/components/nav-bars-shared/nav-bar/icons/sell-with-no-card.svg",
	"./settings.svg": "./src/components/nav-bars-shared/nav-bar/icons/settings.svg",
	"./stock-inventory.svg": "./src/components/nav-bars-shared/nav-bar/icons/stock-inventory.svg",
	"./storage-reports.svg": "./src/components/nav-bars-shared/nav-bar/icons/storage-reports.svg",
	"./table-config.svg": "./src/components/nav-bars-shared/nav-bar/icons/table-config.svg",
	"./table-report.svg": "./src/components/nav-bars-shared/nav-bar/icons/table-report.svg",
	"./tax-data.svg": "./src/components/nav-bars-shared/nav-bar/icons/tax-data.svg",
	"./tax.svg": "./src/components/nav-bars-shared/nav-bar/icons/tax.svg",
	"./team.svg": "./src/components/nav-bars-shared/nav-bar/icons/team.svg",
	"./tickets-report.svg": "./src/components/nav-bars-shared/nav-bar/icons/tickets-report.svg",
	"./tickets-v2.svg": "./src/components/nav-bars-shared/nav-bar/icons/tickets-v2.svg",
	"./tickets.svg": "./src/components/nav-bars-shared/nav-bar/icons/tickets.svg",
	"./users.svg": "./src/components/nav-bars-shared/nav-bar/icons/users.svg",
	"./whats-up.svg": "./src/components/nav-bars-shared/nav-bar/icons/whats-up.svg",
	"./zig-account.svg": "./src/components/nav-bars-shared/nav-bar/icons/zig-account.svg",
	"./zig-tag.svg": "./src/components/nav-bars-shared/nav-bar/icons/zig-tag.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/components/nav-bars-shared/nav-bar/icons sync recursive ^\\.\\/.*\\.svg$";